// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__MyO49","right":"styles_right__3I5P7"};